import { Almacenes } from './../../almacenes/almacenes.entity';
import { DatePipe } from '@angular/common';

export class Reporte {


codigo: string;
descripcion: string;
precio: number;
ult_costo: number;
marca: string;
unidad: string;
ubicacion: string;
pro_costo: number;
saldoinicial: number;
entrada: number;
salida: number;
token: string;

constructor() {

  this.codigo = '';
  this.descripcion = '';
  this.precio = 0;
  this.ult_costo = 0;
  this.marca = '';
  this.unidad = '';
  this.ubicacion = '';
  this.pro_costo = 0;
  this.saldoinicial = 0;
  this.entrada = 0;
  this.salida = 0;
  this.token = '';

}

}


export class Filtros {

  id: string;
  fdesde: string;
  fhasta: string;
  almacen: number;
  ubicacion: number;
  grupo: string;
  unidad: number;
  clasif: number;
  ordenar: number;
  codprov: string;
  codcli: string;
  tipomov: string;
  status: string;
  numero: string;
  tipodoc: string;
  resumen: string;
  codigo: string;
  descripcion: string;
  token: string;

    constructor () {

      const fecha = new Date();
      this.id = '';
      this.fdesde = fecha.getFullYear().toString() + '-' +  (fecha.getMonth() + 1).toString() + '-01' ;
      this.fhasta = new Date().toISOString().slice(0, 10);
      this.almacen = 0;
      this.ubicacion  = 0;
      this.grupo = '';
      this.unidad = 0;
      this.clasif = 0;
      this.ordenar = 0;
      this.codprov = '';
      this.codcli = '';
      this.tipomov = '';
      this.status = '';
      this.numero = '';
      this.tipodoc = '';
      this.resumen = '';
      this.codigo = '';
      this.descripcion = '';
      this.token = '';

    }

}
